import React from 'react';
import { Helmet } from 'react-helmet';
import { TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

interface SEOProps {
    title: [string | string[], string | TOptions];
}

const SEO = ({ title }: SEOProps) => {
    const { t } = useTranslation();
    return (
        <Helmet>
            <title>{t(...title)}</title>
        </Helmet>
    );
};

export default SEO;
